import * as R from "ramda";
import clsx from "clsx";
import { IColuna } from "app/types/IColuna";

export const traduzirNomeColuna = ({nomeColuna, codigoFilialOrcamento, nomeGrid, codigoOuReferencia}:{nomeColuna: string, codigoFilialOrcamento?: string, nomeGrid?: "CONSULTAR_ITENS_ORCAMENTO" | "ITENS_ORCAMENTO", codigoOuReferencia?: "CODIGO" | "REFERENCIA"}) => {
    const resolverNomeColunaEstoqueFilial = () => {


        const codigoFilialColuna = nomeColuna.match(/F([0-9]{2})/)[1]
        return codigoFilialColuna == codigoFilialOrcamento ? "Qtde. Disp" : nomeColuna
    }

    /*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
    const mapColunasItensOrcamento = {
        "OrdemItem": "Ordem",
        "Codigo": "Código",
        "Referencia": "Referência",
        "Descricao": "Descrição",
        "Unidade": "Unid.",
        "Quantidade": "Quant.",
        "QuantidadeSolicitada": "Quant. Solicitada",
        "QuantidadePendente": "Quant. Pendente",
        "EstoqueTotal": "Estoque Total",
        "PrecoUnitario": "Preço Unitário",
        "PorcentagemDescontoUnitario": "% Desc",
        "PreservarDescontoUnitario": "Preserv.",
        "PrecoTotal": "Preço Total",
        "PrecoSolTotal": "Preço Sol. Total",
        "PrecoPendenciaTotal": "Preço Pend. Total",
        "PercentualMarkUp": "% Markup",
        "DespesasInclusas": "Desp Inc.",
        "DescricaoTipoEntrega": "Tipo Entrega",
        "FilialTransferencia": "Filial Transferência",
        "TipoFaturamento": "Faturamento",
        "DataPrevisaoEntrega": "Data Prev. Entrega",
        "ValorSubstituicao": "Valor Subst.",
        "DataMarcadaEntrega": "Data Marc. Ent.",
        "DescricaoTurnoEntrega": "Turno Ent.",
        "VendaSobEncomenda": "Venda Sob Enc.",
        "EncomendaExpressa": "Encomenda Expressa", // 433263
        "EntregaPosterior": "Ent. Post.",
        "AliquotaIPI": "Alíquota IPI",
        "ValorIPI": "Valor IPI",
        "Classe": "Classe",
        "PercentualDesconto": "% Desconto Avançado",
        "PercentualBonificacao": "% Bonificação",
        "PrioridadeMontagem": "Prioridade Montagem", // 456839
        "Mostruário": "Mostruário", // PA 487087
        "Ambiente": "Ambiente",
        "CentroDeCusto": "Centro de Custo",
        "PedidoCompra": "Pedido de Compra",
        "LinhaOrdemCompra": "Linha da Ordem de Compra",
        "Info": "",
        "FilialRetirada": "Filial Retirada",
        "ServicoAgregado": "Serviço Agregado",
        "Cor": "Cor",
        "ModeloProduto": "Modelo",
        "SistemaTintometrico": "Tintométrico",
        "Observacao": "Observação",
        "Acoes": "Ações"
    }
    /*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
    const mapColunasConsultaitens = {
        "CodigoProduto": codigoOuReferencia == "CODIGO" ? "Código" : "Referência",
        "DescricaoProduto": "Descrição",
        "Quantidade": "Quantidade",
        "PrecoProduto" : "Preço Unitário",
        "PorcentagemDescontoUnitario": "% Desc",
        "PreservarDescontoUnitario": "Preserv.",
        "ValorTotal": "Preço Total",
        "PrecoUnitarioTabela" : "Preço Unitário Tabela",
        // Colunas "*": derivadas, calculadas no front (ver COLUNAS_DERIVADAS_CONSULTA_ITENS).
        "PrecoUnitarioTabelaAsterisco" : "Preço Unitário Tabela*",
        "PrecoTotalTabela" : "Preço Total Tabela",
        "PrecoUnitarioAVista" : "Preço à Vista",
        "PrecoTotalAVista": "Total à Vista",
        "PercentualMarkUp": "% Markup",
        "MarkupMinimo": "Markup Mínimo",
        "PrecoVendaMinimoCustoReal" : "Preço Mín. de Venda",
        "PercentualDesconto" : "% Desconto",
        "PercentualDescontoAsterisco" : "% Desconto*",
        "CodigoTipoEntrega": "Tipo Entrega",
        "Carga": "Carga",
        "CodigoFilialRetirada": "Filial Retirada",
        "CodigoServicoAgregado": "Serviço Agregado",
        "TipoFaturamento" : "Faturamento",
        "VendaSobEncomenda": "Venda Sob Enc.",
        "EncomendaExpressa": "Encomenda Expressa", // 433263
        "EntregaPosterior": "Ent. Post.",
        "Mostruário": "Mostruário", // PA 487087
        "QuantidadeDevolvida": "Quantidade Devolvida",
        "NfDevolucao": "NF Devolução",
        "Pendencia": "Estoque Pendente",
        "CentroDeCusto": "Centro de Custo",
        "PedidoCompra" : "Pedido de Compra",
        "LinhaOrdemCompra": "Linha da Ordem de Compra",
        "CodigoFilialTransferencia": "Filial Transferência",
		"NomeVendedor": "Vendedor",
        "Observacao": "Observação",
        "Acoes": "Ações"
    }
    /*


Atenção, se incluir alguma coluna no grid de itens, tem que incluir tambem na consulta de itens (ItemConsultaItens)



*/
    const mapParaUsar = R.includes(nomeGrid, ["ITENS_ORCAMENTO", null, undefined]) ? mapColunasItensOrcamento : mapColunasConsultaitens

    return  nomeColuna in mapParaUsar ? mapParaUsar[nomeColuna] :
            new RegExp(/F[0-9]{2}/).test(nomeColuna) ? resolverNomeColunaEstoqueFilial() :
            nomeColuna
}
